import { generatePath } from 'react-router-dom';
import { Currency, formatBalance } from '@ui/src';
import { OrganizationType } from '../../types';
import { FeeAmountTypeEnum, FeeItem } from '../types';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';

const formatFeesList = (
  list: FeeItem[],
  customerId?: string,
  customerType?: OrganizationType,
  baseCurrency?: Currency,
  currenciesList?: Currency[],
): FeeItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currentCurrency = result?.feeCurrencyId
      ? currenciesList?.find(
          (currency) => currency.id === result?.feeCurrencyId,
        )
      : baseCurrency;

    const currentCurrencyName = currentCurrency?.name;

    result.url = generatePath(
      customerType === OrganizationType.INDIVIDUAL
        ? ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS_FEE
        : ROUTES.CUSTOMERS_CORPORATE_TARIFFS_FEE,
      {
        customerId: customerId as string,
        feeId: result.id,
      },
    );

    const render: Record<string, React.JSX.Element> = {
      name: (
        <div className={cn.feeName}>
          {item.name}
          {item.isModified && <div className={cn.modified}>Modified</div>}
        </div>
      ),
      feeAmountType: (
        <div>
          {result.feeAmountType === FeeAmountTypeEnum.FIXED
            ? 'Fixed value'
            : 'Percent of balance'}
        </div>
      ),
      currency: <div>{currentCurrencyName}</div>,
      writeOffValue: (
        <div>
          {result.feeAmountType === FeeAmountTypeEnum.PERCENT
            ? `${result.feePercentAmount}% ${
                result.feePercentMinAmount || result.feePercentMaxAmount
                  ? `(${
                      result.feePercentMinAmount
                        ? `min: ${formatBalance(
                            result.feePercentMinAmount,
                            baseCurrency,
                          )} ${baseCurrency?.name}`
                        : ''
                    }${
                      result.feePercentMaxAmount
                        ? `${
                            result.feePercentMinAmount ? `, ` : ''
                          }max: ${formatBalance(
                            result.feePercentMaxAmount,
                            baseCurrency,
                          )} ${baseCurrency?.name}`
                        : ''
                    })`
                  : ''
              }`
            : `${formatBalance(
                result.feeFixedAmount || 0,
                currentCurrency,
              )} ${currentCurrencyName}`}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatFeesList;
